























import { Component, Prop, Vue } from "vue-property-decorator";
import HomeSectionTitle from "./HomeSectionTitle.vue";

@Component({
  components: { HomeSectionTitle },
})
export default class HomeSection extends Vue {
  @Prop({ type: String, default: "" }) sectionId!: string;
  @Prop({ type: String, default: "" }) variant!: string;
  @Prop({ type: Boolean, default: false }) full!: boolean;
  @Prop({ type: Boolean, default: false }) screen!: boolean;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "h2" }) titleTag!: string;
  @Prop({ type: Boolean, default: false }) titleShowStar!: boolean;
  @Prop({ type: Number, default: 256 }) titleLineWidth!: number;
  @Prop({ type: Number, default: 56 }) titleLineWidthMobile!: number;
  @Prop({ type: String, default: "0px" }) titleSpacing!: string;

  get variantClass() {
    if (!this.variant) return "";
    return `homeSection--${this.variant}`;
  }
}
